import { api } from '../../lib/api';
import type { HotelReviewDto, VideoStoryDto } from '@pms/shared';

/**
 * Curated storefront content (TASK-62). Reads the public, approved + active
 * subset of super-admin-curated hotel reviews and hotelier video stories.
 *
 * GET /v1/public/reviews?propertyId=…       — testimonials band (homepage / detail)
 * GET /v1/public/video-stories?propertyId=… — hotelier video stories
 *
 * `propertyId` is optional: omit it on the homepage (a capped cross-property
 * band), pass it on a property detail page for that property's own set.
 */

export async function getHotelReviews(
  propertyId?: string,
): Promise<HotelReviewDto[]> {
  const { data } = await api.get<HotelReviewDto[]>('/reviews', {
    ...(propertyId ? { params: { propertyId } } : {}),
  });
  return data;
}

export async function getVideoStories(
  propertyId?: string,
): Promise<VideoStoryDto[]> {
  const { data } = await api.get<VideoStoryDto[]>('/video-stories', {
    ...(propertyId ? { params: { propertyId } } : {}),
  });
  return data;
}
